<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h1">CONTENTS</a></h2><a id="h1">
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup>
<col width="25%"/>
<col width="75%"/>
</colgroup>
<tbody><tr>
<td class="bot" colspan="2" valign="top"><a href="#/04_intro#h2">Introduction and Acknowledgements</a></td>
</tr>
<tr>
<td class="bot" colspan="2" valign="top"><a href="#/05_fm02#h3">Visiting Military Cemeteries</a></td>
</tr>
<tr>
<td class="bot" colspan="2" valign="top"><a href="#/17_fm03#h4">Historical Context</a></td>
</tr>
<tr>
<td class="bot" colspan="2" valign="top"><a href="#/32_fm04#h5">Visiting the Area</a></td>
</tr>
<tr>
<td class="top" valign="top"><a href="#/38_chapter01#h6">Route 1:</a></td>
<td class="top" valign="top"><a href="#/38_chapter01#h6">Bois-Grenier</a></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/59_chapter02#h7" title="Link target outside of Sample">Route 2:</span></td>
<td class="bot" valign="top"><span href="#/59_chapter02#h7" title="Link target outside of Sample">Neuve Chapelle</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/78_chapter03#h8" title="Link target outside of Sample">Route 3:</span></td>
<td class="bot" valign="top"><span href="#/78_chapter03#h8" title="Link target outside of Sample">Aubers</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/96_chapter04#h9" title="Link target outside of Sample">Route 4:</span></td>
<td class="bot" valign="top"><span href="#/96_chapter04#h9" title="Link target outside of Sample">Fromelles and Pheasant Wood</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/127_chapter05#h10" title="Link target outside of Sample">Route 5:</span></td>
<td class="bot" valign="top"><span href="#/127_chapter05#h10" title="Link target outside of Sample">Rue du Bois and the Cinder Track</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/142_chapter06#h11" title="Link target outside of Sample">Route 6:</span></td>
<td class="bot" valign="top"><span href="#/142_chapter06#h11" title="Link target outside of Sample">Festubert</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/154_chapter07#h12" title="Link target outside of Sample">Route 7:</span></td>
<td class="bot" valign="top"><span href="#/154_chapter07#h12" title="Link target outside of Sample">Northern Car Tour</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/192_chapter08#h13" title="Link target outside of Sample">Route 8:</span></td>
<td class="bot" valign="top"><span href="#/192_chapter08#h13" title="Link target outside of Sample">Cuinchy and the Brickstacks</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/213_chapter09#h14" title="Link target outside of Sample">Route 9:</span></td>
<td class="bot" valign="top"><span href="#/213_chapter09#h14" title="Link target outside of Sample">Hohenzollern Redoubt</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/231_chapter10#h15" title="Link target outside of Sample">Route 10:</span></td>
<td class="bot" valign="top"><span href="#/231_chapter10#h15" title="Link target outside of Sample">Lone Tree and the Dump</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/250_chapter11#h16" title="Link target outside of Sample">Route 11:</span></td>
<td class="bot" valign="top"><span href="#/250_chapter11#h16" title="Link target outside of Sample">Hill 70</span></td>
</tr>
<tr>
<td class="bot" valign="top"><span href="#/265_chapter12#h17" title="Link target outside of Sample">Route 12:</span></td>
<td class="bot" valign="top"><span href="#/265_chapter12#h17" title="Link target outside of Sample">Loos Battlefield Car Tour</span></td>
</tr>
<tr>
<td class="top" colspan="2" valign="top"><span href="#/289_reading#h18" title="Link target outside of Sample">Further Reading</span></td>
</tr>
</tbody></table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_contents.vue?3260636e